import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n-bridge";
import IconChevronDown from "~icons/figma/ChevronDown";

export type ContestEntryCopySynopsisSource = "fromNovel" | "fromTheme";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestEntryCopySynopsisSelect',
  emits: ["select"],
  setup(__props, { emit }: { emit: ({
  (e: "select", source: ContestEntryCopySynopsisSource): void;
}), expose: any, slots: any, attrs: any }) {



const { t } = useI18n();
const root = ref<HTMLElement | null>(null);
const isOpen = ref(false);

const options = computed(() => [
  {
    value: "fromNovel" as const,
    label: t("contestEntryForm.step2.copySynopsis.fromNovel"),
  },
  {
    value: "fromTheme" as const,
    label: t("contestEntryForm.step2.copySynopsis.fromTheme"),
  },
]);

function toggle() {
  isOpen.value = !isOpen.value;
}

function close() {
  isOpen.value = false;
}

function onSelect(source: ContestEntryCopySynopsisSource) {
  close();
  emit("select", source);
}

function onDocumentPointerDown(event: PointerEvent) {
  if (!isOpen.value) return;
  const target = event.target as Node | null;
  if (target && root.value?.contains(target)) return;
  close();
}

function onDocumentKeydown(event: KeyboardEvent) {
  if (!isOpen.value) return;
  if (event.key === "Escape") close();
}

onMounted(() => {
  document.addEventListener("pointerdown", onDocumentPointerDown);
  document.addEventListener("keydown", onDocumentKeydown);
});

onBeforeUnmount(() => {
  document.removeEventListener("pointerdown", onDocumentPointerDown);
  document.removeEventListener("keydown", onDocumentKeydown);
});

return { __sfc: true,emit, t, root, isOpen, options, toggle, close, onSelect, onDocumentPointerDown, onDocumentKeydown, IconChevronDown }
}

})